module.exports = __webpack_public_path__ + "img/sprite.2611441c.png";